import axios from "axios";

export default  function logActivity(action_type = '', pincode='') {


  const token = localStorage.getItem("_token");
  if(!token)return;

  if(action_type !== ''){

    if(!log_names.includes(action_type))return;
    
    const logData = {
      action_type: action_type,
    };
    
    axios.post("/tracking/activity", logData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    })
    .then((res) => {
      console.log("Activity logged:", res.data);
    })
    .catch((err) => {
      console.error("Failed to log activity:", err);
    });
  }

  if(pincode !== ''){
    const logData = {
      pincode: pincode,
    };
    
    axios.post("/tracking/search", logData, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    })
    .then((res) => {
      console.log("Searched logged:", res.data);
    })
    .catch((err) => {
      console.error("Failed to log search:", err);
    });
  }
}




export const log_names = ['fav', 'post', 'job', 'account', 'clubhouse', 'how_it_works', 'reviews', 'membership', 'about_us', 'system_recommended_nanny'];



// WEBPACK FOOTER //
// ./src/util/activitylog.js